module.exports = __webpack_public_path__ + "media/soundtrack.cb4b24fe.mp3";